<template>
  <div>
    <div class="mb_head">
      <div class="mb-logo">
        <img src="@/assets/images/0_img_logo_b.jpg" alt="Logo" class="logo" />
      </div>
      <div class="menu" @click="mb_drawer = !mb_drawer">≡</div>
    </div>
    <el-drawer
        :visible.sync="mb_drawer"
        size="330px"
        style="position: absolute;top: 55px"
        direction='rtl'>
      <div class="MobileMenu">
        <div class="nav-item" @click="toDetail('/mb_home')">{{ $t('header.home') }}</div>
        <div class="nav-item" @click="toDetail('/mb_about')">{{ $t('header.about') }}</div>
        <div class="nav-item" @click="toDetail('/mb_technology')">{{ $t('header.technology') }}</div>
        <div class="nav-item" @click="toDetail('/mb_oem')">{{ $t('header.oem') }}</div>
        <div class="nav-item" style="display: flex;justify-content: space-between" @click="showProductsList">
          <span>{{ $t('header.products') }}</span>
          <i style="margin-right: 15px" class="el-icon-arrow-down"></i>
        </div>
        <div class="productList" v-if="productListVisble">
          <div class="li" @click="toDetail('/mb_products')">Reduced Coenzyme Q10</div>
          <div class="li" @click="toDetail('/mb_products_salacia')">Salacia Plus Tablets</div>
          <div class="li" @click="toDetail('/mb_products_gmi')">SK Premium Gel</div>
        </div>
        <div class="nav-item" @click="toDetail('/mb_global_registration')">{{ $t('header.globalRegistration') }}</div>
        <div class="nav-item" style="display: flex;justify-content: space-between">
          <span>{{ $t('header.services') }}</span>
          <i @click="showServicesList" style="margin-right: 15px" class="el-icon-arrow-down"></i>
        </div>
        <div class="serviceList" v-if="serviceListVisble">
          <div class="li" @click="toDetail('/mb_material')">{{ $t('header.rawMaterial') }}</div>
          <div class="li" @click="toDetail('/mb_flow')">{{ $t('header.productCustomization') }}</div>
          <div class="li" @click="toDetail('/mb_business')">{{ $t('header.importExport') }}</div>
        </div>
        <div class="nav-item" @click="toDetail('/mb_contacts')">{{ $t('header.contacts') }}</div>
        <div class="nav-item lang-switch-mb">
          <span :class="{ activeLang: $i18n.locale === 'ja' }" @click="changeLanguage('ja')">JP</span>
          <span class="divider">/</span>
          <span :class="{ activeLang: $i18n.locale === 'en' }" @click="changeLanguage('en')">EN</span>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { Drawer } from 'element-ui';
export default {
  components: {
    'el-drawer': Drawer
  },
  name: "mobileHeadView",
  data() {
    return {
      mb_drawer: false,
      productListVisble: false,
      serviceListVisble: false,
    }
  },
  methods: {
    toDetail(url) {
      this.$router.push(url).catch(err => {
        console.log('输出报错',err)
      })
      this.mb_drawer = false
      this.productListVisble = false
      this.serviceListVisble = false
    },
    showProductsList() {
      this.productListVisble = !this.productListVisble      
    },
    showServicesList() {
      this.serviceListVisble = !this.serviceListVisble
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
  }
}
</script>

<style scoped lang="less">
.lang-switch-mb {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  font-size: 18px;
  .activeLang {
    font-weight: bold;
    color: #409EFF;
  }
  .divider {
    margin: 0 10px;
  }
}
.el-drawer__wrapper {
  /deep/ .el-drawer__header {
    display: none;
  }
}
.mb-logo {
  background-color: #fff;
  .logo {
    width: 95px;
    margin-top: 10px;
  }
}
.mb_head {
  background-color: #fff;
  display: flex;
  position: fixed;
  //height: 100%;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #ccc;
  .menu {
    font-size: 30px;
  }
}
.MobileMenu {
  z-index: 999;
  background-color: #fff;
  //position: fixed;
  //top: 55px;
  //right: 0;
  width: 330px;
  //box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.4);
  //height: 500px;
  .nav-item {
    font-size: 14px;
    padding: 15px 0 15px 20px;
    border-bottom: 1px solid #ccc;
  }
  .serviceList {
    display: block;
    height: 100%;
    .li {
      font-size: 14px;
      height: 50px !important;
      line-height: 50px;
      margin: 0 0  0 100px;
      border-bottom: 1px solid #ccc;
    }
  }
  .productList {
    display: block;
    height: 100%;
    .li {
      font-size: 14px;
      min-height: 50px;
      padding: 14px 0 14px 0;
      line-height: 22px;
      margin: 0 0  0 60px;
      border-bottom: 1px solid #ccc;      
    }
  }
}

</style>
